import React from "react";
import { action } from "store/Project";
import { connect } from "react-redux";
import { Modal, Button } from "antd";
import { API } from "utils/api";
import { getSsoToken } from "utils/sso";

class ResultExportModal extends React.PureComponent {
  /** 拼导出地址：导出是 window.open 的原生跳转，不走 axios 拦截器，
   *  因此需显式把令牌放进 query（后端 lib/sso.py 取令牌时优先读 ssoToken 参数）。 */
  exportUrl(rounds) {
    const token = encodeURIComponent(getSsoToken());
    return `${API.PROJECT_RESULT}/${
      this.props.currentProject
    }?rounds=${rounds}&type=excel&v=${new Date().getTime()}&ssoToken=${token}`;
  }

  render() {
    return (
      <Modal
        visible={this.props.visible}
        onCancel={this.props.closeResultModal}
        title="导出结果"
      >
        <Button
          type="primary"
          onClick={() => {
            window.open(this.exportUrl(1), "_blank");
          }}
        >
          第一轮
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: 10 }}
          onClick={() => {
            window.open(this.exportUrl(2), "_blank");
          }}
        >
          第二轮
        </Button>
      </Modal>
    );
  }
}

const STP = (state) => {
  return {
    visible: state.getIn(["project", "modal", "result"]),
    currentProject: state.getIn(["project", "currentSelect", "project"])
  };
};

const DTP = (dispatch) => {
  return {
    closeResultModal: () => {
      dispatch(action.changeItem(["modal", "result"], false));
      dispatch(
        action.changeItem(["project", "currentSelect", "project"], undefined)
      );
    }
  };
};

export default connect(STP, DTP)(ResultExportModal);
